import EntryLanguageFooter from "../../EntryLanguageFooter";
import React, { useState } from "react";
import { useUser } from "../../../hooks/useApi";
import Loader from "../../basic/Loader";
import DevPre from "../../dev/DevPre";
import "./styles/style.scss";
import InputText from "../../basic/InputText";
import Button from "../../basic/Button";
import { T } from "../../../hooks/useLanguage";
import { useNavigate } from "@reach/router";

import { getRadioEntryPath } from "../../../features/entryFlow/entryIntentStorage";

const Login = function () {
  const radioEntryPath = getRadioEntryPath();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const { login, mutation } = useUser();
  const { isLoading, isError, error } = mutation;

  const handleUpdate = (value, name) => {
    switch (name) {
      case "username":
        setUsername(value);
        break;
      case "password":
        setPassword(value);
        break;
      default:
        break;
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    // handleLogin({ username: username, password: password })
    login(
      { email: username, pass: password, type: "normal" },
      {
        onError: (error) => console.log("onError", error),
        onSettled: (settled) => console.log("onSettled", settled),
        onSuccess: (success) => console.log("onSuccess", success),
      }
    );
  };

  // useEffect(() => {
  //   if (logged) {
  //     navigate(loginRedirect);
  //   }
  //   return () => {
  //     console.log("navigate to profile");
  //   };
  // }, [logged, loginRedirect]);

  return (
    <div className="container login">
      <h1>
        <T>login.title</T>
      </h1>
      <form
        method="post"
        onSubmit={(event) => {
          handleSubmit(event);
        }}
      >
        <InputText
          label={<T>login.email</T>}
          type="text"
          name="username"
          onChange={handleUpdate}
        />
        <Button type="button" block as="link" onClick={() => navigate("/register")}>
          <T>login.forgotpassword</T>
        </Button>
        <InputText
          label={<T>login.password</T>}
          type="password"
          name="password"
          onChange={handleUpdate}
        />
        <Button type="submit" block className="success">
          <T>login.login</T>
        </Button>
      </form>
      <br/>
      {!radioEntryPath && <Button onClick={() => navigate("/")} block as="transparent" style={{color:"white"}}><T>login.back</T></Button>}
      {isError ? (
        <DevPre style={{ color: "red" }}>
          {JSON.stringify(error, null, " ")}
        </DevPre>
      ) : isLoading ? (
        <Loader />
      ) : null}
      <EntryLanguageFooter />
    </div>
  );
};
export default Login;
